<template>
  <button
    class="icon-btn"
    :class="{
      'icon-btn--active': active,
      'icon-btn--disabled': disabled,
    }"
    type="button"
    @click.stop.prevent="handleClick"
    @mousedown.prevent
  >
    <iconic :name="icon" />
  </button>
</template>

<script>
  export default {
    name: "IconButton",
    props: {
      icon: {
        type: String,
        default: "eye",
      },
      active: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      handleClick() {
        if (this.disabled) return;
        this.$emit("click");
      },
    },
  };
</script>

<style lang="scss" scoped>
  .icon-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 6px 8px;
    cursor: pointer;
    color: #8c8c8c;
    user-select: none;
    transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease;
    border-radius: 6px;
    border: 1px solid #e4e4e4;
    background: #f9f9f9;
    width: 28px;
    height: 28px;

    &:hover {
      border: 1px solid $primary-color;
      color: $primary-color;
    }

    &--active {
      border: 1px solid $primary-color;
      color: $primary-color;
      background: #fff;
    }

    &--disabled {
      opacity: 0.4;
      cursor: default;
      pointer-events: none;
    }
  }
</style>
